import { Divider, Typography } from '@mui/material';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import '../../css/processo.css';
import ReactComponent from '../ReactComponent';
import ComplementoAnotacao from './ComplementoAnotacao';
import FerramentasDetalhesProcesso from './FerramentasDetalhesProcesso';
import FerramentasDetalhesProcessoPreSessao from './FerramentasDetalhesProcessoPreSessao';
import FerramentasDetalhesProcessoPauta from './FerramentasDetalhesProcessoPauta';
import DetalhesProcesso from './DetalhesProcesso';

class PainelDetalhes extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed
        });
    }

    get registro() {
        return this.store.processoSelecionado;
    }

    render() {
        if (this.sessaoStore.carregandoProcessos || this.store.carregandoProcessos) {
            return null;
        }
        if (!this.registro) {
            return (
                <Fragment>
                    <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', margin: '10px 0px 10px 0px' }} />
                    <Typography
                        variant="h6"
                        style={{ whiteSpace: 'nowrap', margin: '20px', marginTop: '14px' }}
                    >
                        Não há processo selecionado
                    </Typography>
                </Fragment>
            );
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: '1', padding: '6px 10px' }}>
                {this.renderFerramentasDetalhes()}
                <DetalhesProcesso />
                {this.registro.sessaoId && <ComplementoAnotacao registro={this.registro} />}
            </div>
        );
    }
    renderFerramentasDetalhes() {
        return (
            <>
                {this.routerStore.isSalaSessao && <FerramentasDetalhesProcesso registro={this.registro} />}
                {this.routerStore.isPautaJulgamento && <FerramentasDetalhesProcessoPauta registro={this.registro} />}
                {this.routerStore.isPreSessao && <FerramentasDetalhesProcessoPreSessao registro={this.registro} />}
            </>
        );
    }
}

export default inject('stores')(observer(PainelDetalhes));
